var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "result-splash" },
    [
      _c("p", { staticClass: "result-splash__cta" }, [
        _vm._v(" " + _vm._s(_vm.$t("result.cta")) + " "),
      ]),
      _c(
        "v-button",
        {
          directives: [
            {
              name: "touch",
              rawName: "v-touch:tap",
              value: _vm.seeResults,
              expression: "seeResults",
              arg: "tap",
            },
          ],
          staticClass: "result-splash__button",
          attrs: { light: "" },
        },
        [_vm._v(" " + _vm._s(_vm.$t("result.button")) + " ")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }